import React, { useCallback, memo, useState, useMemo } from "react"
import AnimatedCursor from "./animatedCursor";
import ToggleButton from "./toggleButton"
import VideoPlayer from "./videoPlayer"
const { DateTime } = require("luxon");

const Showreel = ({ video }) => {

  const [muted, setMuted] = useState(true)

  const [currentTime, setCurrentTime] = useState(0)
  const [totalTime, setTotalTime] = useState(0)

  const changeMuted = useCallback(() => {
    setMuted((state) => !state)
  }, [])

  const changeCurrentTime = useCallback(({ playedSeconds }) => {
    const time = DateTime.fromSeconds(playedSeconds).toFormat('mm:ss')
    setCurrentTime(time)
  }, [])

  const changeTime = useCallback((time) => {
    time = DateTime.fromSeconds(time).toFormat('mm:ss')
    setTotalTime(time)
  }, [])

  const [playing, setPlaying] = useState(true)

  return (
    <div className='showreel p10'>
      <AnimatedCursor onClick={() => setPlaying((state) => !state)} text={(playing ? 'Pause' : 'Play')}>
        <Player playing={playing} changeTime={changeTime} changeCurrentTime={changeCurrentTime} muted={muted} video={video} />
      </AnimatedCursor>
      <Controls setPlaying={setPlaying} playing={playing} totalTime={totalTime} onClick={changeMuted} currentTime={currentTime} muted={muted} />
    </div>
  )
}

const Player = memo(({ changeTime, playing, changeCurrentTime, muted, video }) => {


  const year = useMemo(() => {
    return new Date().getFullYear()
  }, [])

  return (
    <div className='ratio-2-1 pos-rel button  '>
      <div className="bg-image video-wrapper">
        <VideoPlayer playing={playing} onDuration={changeTime} onProgress={changeCurrentTime} volume={(muted ? 0 : 1)} muted={muted} url={video} />
        <h1 className="h2 bg-image hide text-light flex align-bottom m0 p20 border-box text-inital pb10 pointer-events-none">Showreel S/A {year}</h1>
      </div>
    </div>
  )
})

const Time = memo(({ currentTime, totalTime }) => {
  const [width, setWidth] = useState(0)

  const time = useCallback((node) => {
    if (node !== undefined && node?.scrollWidth) {
      setTimeout(() => {
        setWidth(node.scrollWidth)
      }, 0)
    }
  }, [])

  return (
    <>
      <span ref={time} style={{ width }} className="text-light inline"> {currentTime ? currentTime : `00:00`} </span>
      <span className="text-light ">—</span>
      <span className="text-normal">{totalTime} MINS</span>
    </>
  )
})

const SoundButton = memo(({ onClick, muted }) => {
  return (
    <button className="flex align-center button " onClick={onClick} >
      <div className="difference" style={{ marginTop: '-10px' }}>
        <ToggleButton ml='' className={('mr10 ' + (!muted ? 'active' : ''))} />
      </div>
      <span>Sound {muted ? 'Off' : 'On'}</span>
    </button>
  )
})

function Controls({ muted, onClick, currentTime, totalTime, setPlaying, playing }) {



  return (
    <div className="pt10 grid-270-1-320-a grid gap-10">
      <SoundButton onClick={onClick} muted={muted} />
      <div />
      <div className="flex align-center">
        <Time totalTime={totalTime} currentTime={currentTime} />
      </div>
      <div className="with-dot mr0 flex align-center" />
    </div>
  )
}


const PlayButton = memo(({ playing, setPlaying }) => {
  return (
    <button onClick={() => setPlaying((state) => !state)} className='flex align-center button play-button'>
      <div style={{ marginTop: '-1px' }} className={" mr10  " + (playing ? 'pause-icon' : 'play-icon')} />
      <span className="uppercase">{!playing ? 'Play' : 'Pause'}</span>
    </button>
  )
})




export default Showreel
